export var config = {
  dev: {},
  stg: {},
  prod: {
    core: window.feConfig.common.apiBaseUrl + "core/",
    media: window.feConfig.common.media,
    orgInit: window.feConfig.common.apiBaseUrl + "orginit/",
    globalApi: window.feConfig.common.scApiBaseUrl + "misc/"
  },
  source: 501
}; // 修改上面config对象 指定环境的域名

export function setDomainConfig(env, domain) {
  config[env] = domain;
}
export default config;